export const Portfolios = [
  {
    id: 1,
    image: "img/portfolio-pizaaApp.png",
    title: "Pizza Restaurant",
    githubLink: "https://github.com/bhagyashreeWalanj/pizza-restaurant",
    demoLink: "https://pizzalama.netlify.app/",
    isPublished: true,
  },
  {
    id: 2,
    image: "img/toDoApp.png",
    title: "To-Do App",
    githubLink: "https://github.com/bhagyashreeWalanj/getir-todo-app",
    demoLink: "https://getir-todo-bhagyashree.netlify.app",
    isPublished: false,
  },
  {
    id: 3,
    image: "img/friends-quiz-app.png",
    title: "Quiz App",
    githubLink: "https://github.com/bhagyashreeWalanj/quiz-app-friends",
    demoLink: "https://friends-trivia.netlify.app/",
    isPublished: false,
  },
  {
    id: 4,
    image: "img/weather-app.png",
    title: "Weather App",
    githubLink: "https://github.com/bhagyashreeWalanj/typescript-weather-app",
    demoLink: "https://bhagyashree-weather-app.herokuapp.com/",
    isPublished: false,
  },
  {
    id: 5,
    image: "img/schedule-mentor.png",
    title: "Mentor Appointment App",
    githubLink: "https://github.com/bhagyashreeWalanj/appointment_calendar",
    demoLink: "https://schedule-mentor.netlify.app/",
    isPublished: false,
  },
  {
    id: 6,
    image: "img/react-autocomplete.png",
    title: "Autocomplete App",
    githubLink: "https://github.com/bhagyashreeWalanj/deel_autocomplete",
    demoLink: "https://deel-autocomplete.herokuapp.com/",
    isPublished: false,
  },
  {
    id: 7,
    image: "img/seasonOfTheYear.png",
    title: "Season Of the Year - Landing Page",
    githubLink: "https://github.com/bhagyashreeWalanj/season-app/tree/master",
    demoLink: "https://season-app-rho.vercel.app/",
    isPublished: true,
  },
  {
    id: 8,
    image: "img/planAndEat.png",
    title: "Season Of the Year",
    githubLink: "https://github.com/bhagyashreeWalanj/mealplanner/tree/master",
    demoLink: "https://meal-planeat.vercel.app/",
    isPublished: true,
  },
];
